import * as React from "react";
import { forwardRef } from "react";
const SvgIconTime = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 4a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 1.333A6.667 6.667 0 1 1 5.333 12 6.657 6.657 0 0 1 12 5.333m-.667 1.333v6H16v-1.333h-3.333V6.667z", "data-name": "icon/time", transform: "translate(-4 -4)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconTime);
export { ForwardRef as ReactComponent };
